module.exports = __webpack_public_path__ + "static/media/whatsapp.eb9c669c.svg";